export default __webpack_public_path__ + "static/pilot-Nicola-e55892e08d174fa1aa191b72b1303619.png";